import React, { useState } from 'react';
import { styled } from '@ff/ui';
import { P16 } from 'client/v3/typography';
import Link from '@ff/ui/Link';
import Modal from 'client/v3/components/CustomizedModal2'
import ModelSelection from 'client/v3/components/ModelSelection'

export default function ChangeModel() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Container>
       <P16 onClick={() => setOpenModal(true)} >Change Model</P16>
      </Container>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <ModelSelection onSelected={() => setOpenModal(false)} />
      </Modal>
    </>
  )
}

const Container = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'underline',
  width: 'fit-content',
  color: 'black',
  marginTop: '28px',
  ':visited': {
    color: 'black'
  }
});
